import React from 'react';
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

import styles from './styles.module.less';

interface ReportTabsBarProps {
  activeKey: string;
  onChange: (key: string) => void;
  items: TabsProps['items'];
  containerRef?: React.Ref<HTMLDivElement>;
  className?: string;
  bleed?: boolean;
}

const ReportTabsBar: React.FC<ReportTabsBarProps> = ({
  activeKey,
  onChange,
  items,
  containerRef,
  className,
  bleed = false,
}) => (
  <div ref={containerRef} className={`${styles.bar} ${bleed ? styles.bleed : ''} ${className ?? ''}`}>
    <Tabs className={styles.tabs} activeKey={activeKey} onChange={onChange} items={items} />
  </div>
);

export default ReportTabsBar;
